/* ═════════════════════════════════════════════════════════════
   Country Road Fashions — search.

   Two jobs, and the second one is the reason this file exists.

   1. The panel. Opens off the masthead's search icon, suggests as you type,
      hands off to the results page. Behaviour carried over from V5.

   2. **Quoting.** Shopify's storefront search is typo-tolerant on a bare term.
      On a catalogue that is 178 shirts, that is ruinous: `q=linen` returns 148
      products and every one of them is poplin, because "lin" is one edit from
      "lin" inside "poplin". Quote the term and tolerance switches off --
      `q="linen"` returns nothing, which is the truth, and `q="blue" "poplin"`
      returns the six there are.

      So every search form on the site submits quoted terms. The catch is that
      quoting also kills prefix matching (`q="popl"` finds nothing), which a
      typeahead needs, so the typeahead queries unquoted and then checks each
      title itself before showing it. Loose query, strict filter.

   Without JavaScript every form still submits and still finds things, just
   loosely. That is the old behaviour, not a broken one.
   ═════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var ROOT = document.querySelector('[data-crf-search]');
  var DEBOUNCE = 200;
  var LIMIT = 6;

  /* ── Terms ──────────────────────────────────────────────────
     Split a raw field value into terms, honouring quotes the visitor typed
     themselves so `"grey flannel"` stays one phrase. */
  function terms(raw) {
    var out = [];
    var re = /"([^"]+)"|(\S+)/g;
    var m;
    while ((m = re.exec(raw)) !== null) {
      var t = (m[1] || m[2] || '').trim();
      if (t) out.push(t);
    }
    return out;
  }

  function quoted(raw) {
    return terms(raw)
      .map(function (t) { return '"' + t.replace(/"/g, '') + '"'; })
      .join(' ');
  }

  /* Every form, not only the panel's: the shop's field and the menu's field
     submit into the same search and would otherwise return the same 148
     shirts. */
  function armForms() {
    var forms = document.querySelectorAll('form[data-crf-search-form]');
    Array.prototype.forEach.call(forms, function (form) {
      if (form.dataset.crfArmed === '1') return;
      form.dataset.crfArmed = '1';
      form.addEventListener('submit', function () {
        var field = form.querySelector('input[name="q"]');
        if (!field) return;
        var q = quoted(field.value);
        if (!q) return;
        /* The field is rewritten for the moment of submission and put back, so
           a visitor who uses the browser's back button does not find their own
           words in quotation marks they never typed. */
        var typed = field.value;
        field.value = q;
        window.setTimeout(function () { field.value = typed; }, 0);
      });
    });
  }

  armForms();
  document.addEventListener('shopify:section:load', armForms);

  if (!ROOT) return;

  var panel = ROOT.querySelector('.crf-searchbar__panel');
  var form = ROOT.querySelector('form[data-crf-search-form]');
  var field = ROOT.querySelector('.crf-searchbar__input');
  var list = ROOT.querySelector('.crf-searchbar__results');
  var status = ROOT.querySelector('[data-crf-search-status]');
  var toggle = document.querySelector('[data-crf-search-toggle]');
  if (!panel || !form || !field || !list) return;

  var money = ROOT.dataset.moneyFormat || '{{amount}}';
  var hiddenTags = (ROOT.dataset.hiddenTags || '')
    .split(',')
    .map(function (t) { return t.trim().toLowerCase(); })
    .filter(Boolean);
  var searchUrl = ROOT.dataset.searchUrl || '/search';
  var allLabel = ROOT.dataset.allLabel || 'See all results';
  var noneLabel = ROOT.dataset.noneLabel || 'Nothing in the catalogue is called';

  var timer = null;
  var pending = null;
  var cursor = -1;
  var rows = [];
  var lastQuery = '';

  /* ── Open and close ─────────────────────────────────────── */
  function open() {
    if (panel.dataset.open === 'true') return;
    panel.dataset.open = 'true';
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    window.setTimeout(function () { field.focus(); }, 60);
  }

  function close(returnFocus) {
    if (panel.dataset.open !== 'true') return;
    panel.dataset.open = 'false';
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
      if (returnFocus) toggle.focus();
    }
    clear();
  }

  if (toggle) {
    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      if (panel.dataset.open === 'true') close(true);
      else open();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && panel.dataset.open === 'true') close(true);
  });

  /* A click anywhere outside closes it, the same way the Shop directory does.
     Pointerdown rather than click so a drag that starts inside the panel and
     ends outside it does not count. */
  document.addEventListener('pointerdown', function (e) {
    if (panel.dataset.open !== 'true') return;
    if (ROOT.contains(e.target)) return;
    if (toggle && toggle.contains(e.target)) return;
    close(false);
  });

  /* ── Formatting ─────────────────────────────────────────── */
  /* suggest.json hands prices back as decimal strings in the shop's own units
     -- "2000.00" for a two-thousand-baht shirt -- while the rest of Shopify's
     JSON deals in cents. Both shapes are accepted here rather than guessed at,
     because getting it wrong turns ฿2,000 into ฿20 and nobody reading the
     panel would know. */
  function formatMoney(raw) {
    var n = typeof raw === 'string' && raw.indexOf('.') > -1
      ? parseFloat(raw)
      : Number(raw || 0) / 100;
    if (!isFinite(n)) n = 0;
    var abs = Math.abs(n);
    var whole = Math.floor(abs).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var decimals = Math.round((abs - Math.floor(abs)) * 100);
    var amount = whole + '.' + (decimals < 10 ? '0' : '') + decimals;
    return money.replace(/\{\{\s*amount[^}]*\}\}/, (n < 0 ? '-' : '') + amount);
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Mark every typed term where it appears in the title, so a visitor can see
     why a row is on the list. */
  function markUp(title, list_) {
    /* Sentinels rather than tags, so a second term cannot land inside the
       markup the first one wrote. */
    var safe = String(title);
    list_.forEach(function (t) {
      var pattern = t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      safe = safe.replace(new RegExp('(' + pattern + ')', 'ig'), '\u0001$1\u0002');
    });
    return escapeHtml(safe)
      .replace(/\u0001/g, '<mark>')
      .replace(/\u0002/g, '</mark>');
  }

  /* ── The filter that does the real work ─────────────────────
     Shopify answered loosely; this decides what was actually asked for. Every
     term has to appear in the title or the product type, as typed. A run
     inside a longer word counts, which is what lets a half-typed `popl` still
     find poplin -- and `linen` still does not appear anywhere in "Blue
     Poplin", which is the whole point. */
  function matches(product, list_) {
    var title = (product.title || '').toLowerCase();
    var type = (product.product_type || product.type || '').toLowerCase();
    var hay = title + ' ' + type;
    for (var i = 0; i < list_.length; i++) {
      var t = list_[i].toLowerCase();
      if (hay.indexOf(t) === -1) return false;
    }
    return true;
  }

  function isHidden(product) {
    if (!hiddenTags.length) return false;
    var tags = product.tags || [];
    for (var i = 0; i < tags.length; i++) {
      if (hiddenTags.indexOf(String(tags[i]).trim().toLowerCase()) !== -1) return true;
    }
    return false;
  }

  /* ── Rendering ──────────────────────────────────────────── */
  function clear() {
    list.innerHTML = '';
    list.dataset.state = 'idle';
    rows = [];
    cursor = -1;
    field.setAttribute('aria-expanded', 'false');
    field.removeAttribute('aria-activedescendant');
    if (status) status.textContent = '';
  }

  function announce(text) {
    if (status) status.textContent = text;
  }

  function render(products, list_, raw) {
    list.innerHTML = '';
    rows = [];
    cursor = -1;

    var href = searchUrl + '?q=' + encodeURIComponent(quoted(raw)) + '&type=product';

    if (!products.length) {
      var none = document.createElement('p');
      none.className = 'crf-searchbar__none';
      none.innerHTML = escapeHtml(noneLabel) + ' <strong>' + escapeHtml(raw) + '</strong>.';
      list.appendChild(none);
      list.dataset.state = 'empty';
      field.setAttribute('aria-expanded', 'true');
      announce(noneLabel + ' ' + raw);
      return;
    }

    products.forEach(function (p, i) {
      var a = document.createElement('a');
      a.className = 'crf-searchbar__row';
      a.href = p.url;
      a.id = 'CrfSearchRow-' + i;
      a.setAttribute('role', 'option');
      a.setAttribute('aria-selected', 'false');

      var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
      var kind = p.product_type || p.type || '';
      var price = p.price_min != null ? p.price_min : p.price;

      a.innerHTML =
        '<span class="crf-searchbar__plate">' +
          (img ? '<img src="' + escapeHtml(img) + '" alt="" loading="lazy" width="44" height="60">' : '') +
        '</span>' +
        '<span class="crf-searchbar__name">' + markUp(p.title, list_) +
          (kind ? '<span class="crf-searchbar__kind">' + escapeHtml(kind) + '</span>' : '') +
        '</span>' +
        '<span class="crf-searchbar__price">' + escapeHtml(formatMoney(price)) + '</span>';

      list.appendChild(a);
      rows.push(a);
    });

    var all = document.createElement('a');
    all.className = 'crf-searchbar__all';
    all.href = href;
    all.innerHTML = escapeHtml(allLabel) + '<span aria-hidden="true">&#8594;</span>';
    list.appendChild(all);

    list.dataset.state = 'results';
    field.setAttribute('aria-expanded', 'true');
    announce(products.length + (products.length === 1 ? ' product' : ' products'));
  }

  /* ── Fetching ───────────────────────────────────────────── */
  function suggest(raw) {
    var list_ = terms(raw);
    if (!list_.length) { clear(); return; }

    /* Unquoted on purpose: quoting would turn off the prefix match that a
       half-typed word depends on. The looseness is undone by matches(). */
    var url = '/search/suggest.json?q=' + encodeURIComponent(raw) +
      '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last';

    if (pending) pending.abort();
    pending = typeof AbortController === 'function' ? new AbortController() : null;

    fetch(url, pending ? { signal: pending.signal } : undefined)
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (data) {
        if (raw !== field.value) return;
        var products = ((data.resources || {}).results || {}).products || [];
        var kept = products.filter(function (p) {
          return !isHidden(p) && matches(p, list_);
        }).slice(0, LIMIT);
        render(kept, list_, raw);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        /* A failed suggestion is not a failed search -- the form still works,
           so the panel says nothing and lets them press return. */
        clear();
      });
  }

  field.addEventListener('input', function () {
    var raw = field.value.trim();
    if (raw === lastQuery) return;
    lastQuery = raw;
    window.clearTimeout(timer);
    if (raw.length < 2) { clear(); return; }
    timer = window.setTimeout(function () { suggest(raw); }, DEBOUNCE);
  });

  /* ── Keyboard ───────────────────────────────────────────── */
  function focusRow(i) {
    if (!rows.length) return;
    if (cursor > -1 && rows[cursor]) rows[cursor].setAttribute('aria-selected', 'false');
    cursor = (i + rows.length) % rows.length;
    var row = rows[cursor];
    row.setAttribute('aria-selected', 'true');
    field.setAttribute('aria-activedescendant', row.id);
    row.scrollIntoView({ block: 'nearest' });
  }

  field.addEventListener('keydown', function (e) {
    if (!rows.length) return;
    if (e.key === 'ArrowDown') { e.preventDefault(); focusRow(cursor + 1); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); focusRow(cursor - 1); }
    else if (e.key === 'Enter' && cursor > -1) { e.preventDefault(); rows[cursor].click(); }
  });
})();
